<template>
  <v-card class="fill-height info_card" title="Team Logo">
    <template v-slot:append>
      <ActionButton
        v-if="team.avatar && team.avatar.id"
        variant="text"
        icon
        @click="isTeamLogoEdit = !isTeamLogoEdit">
        <v-icon icon="mdi-pencil"></v-icon>
      </ActionButton>
    </template>
    <v-card-text>
      <v-container>
        <v-card-title v-if="team.avatar && team.avatar.id && !isTeamLogoEdit" class="text-h5">
          {{ team.avatar.caption }}
        </v-card-title>
        <v-card-subtitle v-if="team.avatar && team.avatar.id && !isTeamLogoEdit"> </v-card-subtitle>
        <v-form v-if="!team.avatar || isTeamLogoEdit">
          <div class="text-medium-emphasis mb-3">Team Logos should be in 16x9 aspect ratio</div>
          <v-row>
            <v-col>
              <v-file-input v-model="file" accept="image/*" label="Choose a file"></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn block variant="elevated" color="secondary" @click="isTeamLogoEdit = false"
                >Cancel</v-btn
              >
            </v-col>
            <v-col>
              <v-btn block variant="elevated" color="primary" :disabled="!file" @click="uploadFile"
                >Upload</v-btn
              >
            </v-col>
          </v-row>

          <v-alert v-if="uploadStatus" :type="uploadStatus.type" dismissible>
            {{ uploadStatus.message }}
          </v-alert>
        </v-form>
        <div
          v-if="team.avatar && team.avatar.id && !isTeamLogoEdit"
          class="d-flex flex-column align-center justify-center">
          <v-img :src="team.avatar.url" contain width="100%" max-height="300">
            <template #sources>
              <source :srcset="team.avatar?.webp_url" />
            </template>
          </v-img>
          <v-divider></v-divider>
          <a
            :href="team.avatar.url"
            download
            class="text-decoration-none text-primary text-body-2 font-weight-medium">
            <v-btn block color="primary" class="rounded-lg mb-8" elevation="2"> Download </v-btn>
          </a>
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { ITeamDTO, TeamDTO } from '@/dtos';
import { ref, toRef } from 'vue';
import {
  createProgressHandler,
  IUploadStatus,
  UPLOAD_NOFILE,
  uploadTeamLogo,
} from '@/controllers/uploadController';
interface Props {
  team: ITeamDTO;
}
const props = defineProps<Props>();
const emit = defineEmits(['logoUpdated', 'snack']);
const team = toRef(props, 'team', new TeamDTO());

const isTeamLogoEdit = ref(false);

const file = ref<File>();
const uploadStatus = ref<IUploadStatus | undefined>();
const uploadTeamAvatarProgress = ref<number | null>(null);
const uploadTeamAvatarCompleted = ref<boolean>(false);

const uploadFile = async () => {
  if (!file.value) {
    uploadStatus.value = UPLOAD_NOFILE;
    return;
  }

  if (!team.value) {
    return;
  }
  try {
    const progress = createProgressHandler(uploadTeamAvatarProgress, uploadTeamAvatarCompleted);
    await uploadTeamLogo(team.value.id, file.value, progress).then(async () => {
      isTeamLogoEdit.value = false;
      emit('logoUpdated');
      emit('snack', 'Team Logo', 'success:update', '');

      file.value = undefined;
    });
  } catch (error: unknown) {
    emit('snack', 'Team Logo', 'error', error as string);
  }
};
</script>
